"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = void 0;
const validate_1 = require("../validate");
function deepCopy(object) {
    if ((0, validate_1.isNullOrUndef)(object)) {
        return object;
    }
    return JSON.parse(JSON.stringify(object));
}
exports.deepCopy = deepCopy;
